import { Utils } from 'formiojs';
export default [
    {
        label: 'CAPTCHA provider',
        widget: 'choicesjs',
        tableView: true,
        data: {
            values: [
                {
                    label: 'Google reCAPTCHA',
                    value: 'google'
                },
                {
                    label: 'Cloudflare Turnstile',
                    value: 'cloudflare'
                }
            ]
        },
        key: 'provider',
        type: 'select',
        input: true,
        defaultValue: 'google'
    },
    {
        key: 'eventType',
        label: 'Type of event',
        tooltip: 'Specify type of event that this reCAPTCHA would react to',
        type: 'radio',
        values: [
            {
                label: 'Form Load',
                value: 'formLoad'
            },
            {
                label: 'Button Click',
                value: 'buttonClick'
            }
        ]
    },
    {
        type: 'select',
        input: true,
        label: 'Button Key',
        key: 'buttonKey',
        dataSrc: 'custom',
        valueProperty: 'value',
        tooltip: 'Specify key of button on this form that this reCAPTCHA should react to',
        customConditional: function (context) {
            return context.data.eventType === 'buttonClick';
        },
        data: {
            custom: function (context) {
                return Utils.getContextButtons(context);
            }
        }
    },
    {
        label: 'Visible Verification',
        defaultValue: true,
        key: 'isVisibleVerification',
        conditional: {
            show: true,
            conjunction: 'all',
            conditions: [
                {
                    component: 'provider',
                    operator: 'isEqual',
                    value: 'cloudflare'
                }
            ]
        },
        type: 'checkbox',
        tooltip: 'If checked, space will be added for the CAPTCHA widget',
        input: true
    },
    {
        key: 'label',
        ignore: true
    },
    {
        key: 'hideLabel',
        ignore: true
    },
    {
        key: 'labelPosition',
        ignore: true
    },
    {
        key: 'placeholder',
        ignore: true
    },
    {
        key: 'description',
        ignore: true
    },
    {
        key: 'tooltip',
        ignore: true
    },
    {
        key: 'errorLabel',
        ignore: true
    },
    {
        key: 'customClass',
        ignore: true
    },
    {
        key: 'tabindex',
        ignore: true
    },
    {
        key: 'multiple',
        ignore: true
    },
    {
        key: 'clearOnHide',
        ignore: true
    },
    {
        key: 'hidden',
        ignore: true
    },
    {
        key: 'mask',
        ignore: true
    },
    {
        key: 'dataGridLabel',
        ignore: true
    },
    {
        key: 'disabled',
        ignore: true
    },
    {
        key: 'autofocus',
        ignore: true
    },
    {
        key: 'tableView',
        ignore: true
    },
    {
        key: 'modalEdit',
        ignore: true
    }
];
